import { TimePicker } from '@mui/lab';
import { Block } from '@attom';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import locale from 'date-fns/locale/fr';
import AdapterJalali from '@date-io/date-fns-jalali';
import { useRef } from 'react';

import CS from './Timepicker.module.scss';

export const Timepicker = ({
	// box control=
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	//
	elSpace = '',
	elClass = '',
	iconClass = '',
	// custom props:
	value = null,
	onChange = null,
	placeholder = '',
	label = '',

	...props
}) => {
	const pickerRef = useRef();

	const changeHandler = (e) => {
		if (onChange) onChange(e);
	};

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace}>
			<LocalizationProvider dateAdapter={AdapterJalali} locale={locale}>
				<TimePicker
					label='Basic example'
					value={value}
					onChange={changeHandler}
					// renderInput={(params) => <TextField {...params} />}
					renderInput={({ inputRef, inputProps, InputProps }) => (
						<div className={`${CS.container}`}>
							<input
								ref={inputRef}
								{...inputProps}
								className={`${CS.input} ${elClass} ${elSpace} direction-ltr  ${value === 'invalid' ? 'tc-danger' : ''}`}
								placeholder={placeholder}
							/>
							{label && <span className={CS.label}>{label}</span>}
							<span className={`${CS.icon} ${iconClass}`} ref={pickerRef}>
								{InputProps?.endAdornment}
							</span>
						</div>
					)}
				/>
			</LocalizationProvider>
		</Block>
	);
};
